import DashboardHeader from "@/components/DashboardHeader";
import SelectInput from "@/components/selectInput/SelectInput";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";
import { FiEdit2 } from "react-icons/fi";
import {
    guestsPerBartenderDrop,
    // percentageTips,
    SUPPLIES,
} from "@/constants/CompanyData";
import React, { useState, useEffect, useMemo, FC } from "react";
import { useForm } from "react-hook-form";
import { AddOnsCalInterface, AddOnsInterface } from "../interface";
// import { PieChart } from "@/components/pieChart/Piechart";
import ToggleInput from "@/components/toggle/Toggle";

import "./Calculator.css";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import { DELETE, GET, PATCH, POST_MULTIPART } from "@/services/api";
import { CustomSupply, Package, PackageType } from "@/interfaces/Package";

import Alert from "@/components/alert/Alert";
import useLoading from "@/hooks/useLoading";
import FormModal from "@/components/modals/FormModal";
import { FaCirclePlus, FaCirclePlay } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import useError from "@/hooks/useError ";
import ImageUploadFunDropZone from "@/utils/ImageUploadDropZoneFun";
import ChangesAlert from "@/components/alert/ChangesAlert";
import CustomSupplies from "./components/CustomSupplies";
import ManagePackage from "./components/ManagePackage";
import AddOnModal from "./modals/AddOnModal";
import AddNewPackageModal from "./modals/AddNewPackageModal";
import EditPackageModal from "./modals/EditPackageModal";
import VideoModal from "./modals/VideoModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import DrinkRow, { type Drinker } from "../../Quote/components/Drinker";
import {
    convertDollarToCents,
    formatNumber,
    Loader,
    USFormatePriceWithDecimal,
} from "@thdinc/hpf-shared";
import { useWindowSize } from "@/hooks/useWindowSize";
import { useDecimalField } from "@/hooks/useDecimalInput";
import { convertCentsToDollars } from "@thdinc/hpf-shared";
import { Props, PackageForm } from "./types/priceCalculation.types";
import {
    portableBar,
    iceCubes,
    defaultAddonImg,
    defaultAddons,
    // DEFAULT_TEXT_CUSTOM_DESCRIPTION, // moved to Business section (MyBusiness.tsx)
    SECTION_HELP_VIDEOS,
    PACKAGE_INCLUDES_HTML,
    GUEST_RANGE_STEPS,
    FREE_MILES,
} from "./constants/priceCalculation.constants";
import {
    getAddonPrice,
    calculateEstimatedTotals,
    DynamicNumbers,
    getStraightLineMiles,
    getBillableMiles,
    getMileageCharge,
    GeoPoint,
} from "./utils/priceCalculation.utils";
import PlacesInput from "@/components/input/PlacesInput";

const PriceCalculation: FC<Props> = ({ params }) => {
    const { roles } = useAppSelector((store: any) => store.user);
    const { width } = useWindowSize();
    const [hrToRegister, setHrToRegister] = useState(3);
    const [isNewPackage, setIsNewPackage] = useState<boolean>(true);
    const [addOns, setAddOns] = useState<AddOnsCalInterface[]>([]);
    const [addAddOnForm, setAddOnForm] = useState<boolean>(false);
    const [addNewPackageForm, setAddNewPackageForm] = useState<boolean>(false);
    const [packageFormEditForm, setPackageFormEditForm] =
        useState<boolean>(false);
    const [activeStatus, setActiveStatus] = useState<boolean>(false);
    const [addOnName, setAddOnName] = useState<string>("");
    const [addOnType, setAddOnType] = useState<string>("bartender");
    const [addOnPrice, setAddOnPrice] = useState("");
    const [addOnCost, setAddOnCost] = useState("");
    const [addOnMinPrice, setAddOnMinPrice] = useState("");
    const [isEditByBtC, setIsEditByBtC] = useState<boolean>(true);
    const [guest, setGuest] = useState(25);
    const [drinker, setDrinker] = useState<Drinker>("medium");
    const [selectedGuests, setSelectedGuests] = useState(75);
    const [percentageTip, setPercentageTip] = useState(15);
    const [selectedGuestBeer, setSelectedGuestBeer] = useState(75);
    const [addOnError, setAddOnError] = useState<string>("");
    const [bartenderPrepTime, setBartenderPrepTime] = useState(60);
    // const [tipFee, setTipFee] = useState(0);
    const [bartenderCost, setBartenderCost] = useState(0);
    const [bartenderPrice, setBartenderPrice] = useState(0);
    // const [bartenderTips, setBartenderTips] = useState(0);
    const [bartenderPriceP, setBartenderPriceP] = useState(0);
    const [deliveryCost, setDeliveryCost] = useState(0);
    const [additionalProfit, setAdditionalProfit] = useState(0);
    const [deliveryPrice, setDeliveryPrice] = useState(0);
    const [suppliesCosts, setSuppliesCosts] = useState(0);
    const [suppliesPrice, setSuppliesPrice] = useState(0);
    // const [distance, setDistance] = useState(30);
    // const [mileageCost, setMileageCost] = useState(0);
    // const [mileagePrice, setMileagePrice] = useState(0);
    const [disableDistance, setDisableDistance] = useState(false);
    const [maxDistance, setMaxDistance] = useState(30);
    const [maxDistanceError, setMaxDistanceError] = useState("");
    const [mileageFee, setMileageFee] = useState(0);
    const [businessAddress, setBusinessAddress] = useState<
        (GeoPoint & { address: string }) | null
    >(null);
    const [eventAddress, setEventAddress] = useState<
        (GeoPoint & { address: string }) | null
    >(null);
    const [Bpp, setBpp] = useState(0);
    const [Mpp, setMpp] = useState(0);
    // Replaced by the cocktail supplies breakdown table (see cocktailSupplies/cocktailSuppliesTotal below).
    // const [SPP, setSPP] = useState(0);
    const [showBpp, setShowBpp] = useState(true);
    // const [showBtp, setShowBtp] = useState(false);
    const [showCMP, setShowCMP] = useState(true);
    // const [showCSP, setShowCSP] = useState(true);
    const [tipJar, setTipJar] = useState(false);
    const [fixedPrice, setFixedPrice] = useState(0);
    const [minPackageTime] = useState(1);
    const [modal, setModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deletePackageId, setDeletePackageId] = useState<string | undefined>(
        ""
    );
    const [videoModal, setVideoModal] = useState<{
        isOpen: boolean;
        title: string;
        url: string;
    }>({ isOpen: false, title: "", url: "" });
    const openVideoModal = (title: string, url: string) =>
        setVideoModal({ isOpen: true, title, url });
    const closeVideoModal = () =>
        setVideoModal((prev) => ({ ...prev, isOpen: false }));
    const {
        getRevnuePackage,
        getCompanyApi,
        singlePackageApi,
        // updateCustomQuoteDescription, // moved to Business section (MyBusiness.tsx)
        packageGarnishes,
        addPackageApi,
        packageDefaultSupplies,
        packages,
    } = API_ROUTES;
    const [packageList, setPackageList] = useState<Package[]>([]);
    const [curPackage, setCurPackage] = useState<Package | null>();
    const [livePackageId, setLivePackageId] = useState<string>("");
    // Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
    // const [customQuotePackageId, setCustomQuotePackageId] = useState<string>("");
    // const [customQuoteDescription, setCustomQuoteDescription] = useState<string>(DEFAULT_TEXT_CUSTOM_DESCRIPTION);
    // const [isCustomQuoteUpdating, setIsCustomQuoteUpdating] = useState<boolean>(false);
    const [minPackagePrice, setMinPackagePrice] = useState(0);
    // const [customBartenderTip, setCustomBartenderTip] = useState(0);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const { refreshToken, business_id } = useAppSelector((store) => store.user);
    // const [selectedGuestsInput, setSelectedGuestsInput] = useState(75);

    const [BP, setBP] = useState(true);
    const [CP, setCP] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [CPF, setCPF] = useState(true);
    const [paymentProcessingFeeRate, setPaymentProcessingFeeRate] = useState(10);
    const [bTips, setBTips] = useState(false);
    const [includeBeerAndWine, setIncludeBeerAndWine] = useState(false);
    const [mAddOnTotal, setMaddOnTotal] = useState(true);
    const [mIceAndCoolerTotal, setmIceAndCoolerTotal] = useState(true);
    const [CST, setCST] = useState(true);
    const [GPB, setGPB] = useState(false);
    const [marketingExpense, setMarketingExpense] = useState(0);
    const [insuranceExpense, setInsuranceExpense] = useState(0);
    const [otherExpense, setOtherExpense] = useState(0);
    const [addOnIsEdit, setAddOnIsEdit] = useState<boolean>(false);
    const [addOnImage, setAddOnImage] = useState<{ file?: File; img: string }>();
    const [addOnDesc, setAddOnDesc] = useState<string>("");
    const [includeInPackage, setIncludeInPackage] = useState<boolean>(false);
    const [addOnPrepTime, setAddOnPrepTime] = useState<boolean>(false);
    const [suppliesList, setSuppliesList] = useState([]); // all supplies list
    const [totalSuppliesList, setTotalSuppliesList] = useState(SUPPLIES); // all supplies list
    const [selectedSupplies, setSelectedSupplies] = useState<string[]>(["Mixers", "Garnishes",
        "Cups",
        "Straws",
        "Napkins",
        "Cocktail Menu",
        "Bartender(s) plus their tools",
        "Up to 4x signature cocktails"]); // selected list
    const [selectedType, setSelectedType] = useState<string>("standard");
    const [addSupplyForm, setAddSupplyForm] = useState<boolean>(false);
    const [supplyInput, setSupplyInput] = useState<string>("");
    const closeAddOnModal = () => setAddOnForm(false);
    const [addOnId, setAddOnId] = useState<string>();
    // const [btp, setbtp] = useState(0);
    const dispatch = useDispatch();
    const [error, setCustomError] = useError();
    const [addError, setAddError] = useState<string>("");
    const [supplyDescription, setSupplyDescription] = useState<string>("");
    const [defaultSupplies, setDefaultSupplies] = useState<CustomSupply[] | null>(
        null
    );
    const [customSupplies, setCustomSupplies] = useState<CustomSupply[] | null>(
        null
    );
    const [canSubmit, setCanSubmit] = useState<boolean>(true);
    const [customSupTotalPlus, setCustomSupTotalPlus] = useState<number>(0);
    const {
        register,
        watch,
        trigger,
        formState: { errors: packageFormErrors },
        setValue,
        reset,
    } = useForm<PackageForm>({
        defaultValues: { prepTime: 60 },
    });
    // console.log('percentageTip-------------:::', percentageTip)
    const businessId = params?.currentBusiness
        ? params
        : useAppSelector((store) => store.business);
    const [businessName, setBusinessName] = useState<string>(
        () => params?.businessName?.trim() || "",
    );

    const effectiveBusinessIdForName = params?.currentBusiness ?? business_id;

    useEffect(() => {
        if (params?.businessName?.trim()) {
            setBusinessName(params.businessName.trim());
        }
        if (!effectiveBusinessIdForName || !refreshToken) return;
        let cancelled = false;
        (async () => {
            try {
                const res = await GET(
                    `${getCompanyApi}/${effectiveBusinessIdForName}`,
                    refreshToken,
                );
                if (cancelled) return;
                const name = res?.data?.name;
                if (
                    !params?.businessName?.trim() &&
                    typeof name === "string" &&
                    name.trim()
                ) {
                    setBusinessName(name.trim());
                }
                // location is a PostGIS point: coordinates = [lng, lat]
                const coordinates = res?.data?.location?.coordinates;
                if (res?.data?.address1 && coordinates?.length === 2) {
                    setBusinessAddress({
                        address: res.data.address1,
                        lat: Number(coordinates[1]),
                        lng: Number(coordinates[0]),
                    });
                }
            } catch {
                /* keep empty */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [params?.businessName, effectiveBusinessIdForName, refreshToken, getCompanyApi]);

    useEffect(() => {
        getPackageList();
        // getGarnishes();
    }, []);
    const getGarnishes = async () => {
        const { data } = await GET(`${packageGarnishes}`, refreshToken);
        const supplies = [
            ...data.map((item: any) => item.charAt(0).toUpperCase() + item.slice(1)),
        ];
        const selectedSet = new Set(selectedSupplies);
        const remainingSupplies = supplies.filter((item) => !selectedSet.has(item));
        const sortedArray = [...selectedSet, ...remainingSupplies];
        setTotalSuppliesList([...sortedArray]);
    };
    useEffect(() => {
        let data: AddOnsCalInterface[] = [];
        if (curPackage) {
            setBartenderCost(curPackage.bartenderCost / 100);
            // setCustomBartenderTip(curPackage.minTips / 100);
            setBartenderPrice(
                (curPackage.bartenderPrice - curPackage.bartenderCost) / 100
            );
            setSelectedGuests(curPackage.guestsPerBartender);
            // setSelectedGuestsInput(curPackage.guestsPerBartender);
            setBartenderPrepTime(curPackage.prepMins);
            setSuppliesCosts(curPackage.suppliesCost / 100);
            setSuppliesPrice(
                (curPackage.suppliesPrice - curPackage.suppliesCost) / 100
            );
            setBartenderPrepTime(curPackage.prepMins);
            setDeliveryCost(curPackage.deliveryFee / 100);
            setMaxDistance(curPackage.radius || 30);
            setMileageFee((curPackage.mileageFee || 0) / 100);
            setInsuranceExpense(curPackage.insuranceExpense / 100);
            setMarketingExpense(curPackage.marketingExpense / 100);
            setOtherExpense((curPackage.otherExpense || 0) / 100);
            setTipJar(!curPackage.tipsOptional);
            setSupplyDescription(curPackage.description);
            setAdditionalProfit(curPackage.additionalProfit / 100);
            setActiveStatus(curPackage.isActive);
            setSelectedType(curPackage.type);
            setValue("packageName", curPackage.name);
            // setSelectedGuestCocktails(curPackage.guestsPerCocktail)
            setSelectedGuestBeer(curPackage.guestsPerBeer || 75);
            let customSupTotal = 0;
            curPackage?.customSupply &&
                setCustomSupplies(
                    curPackage?.customSupply.map((i) => {
                        i.profit = i?.price - i?.cost;
                        customSupTotal += i.price;
                        return i;
                    })
                );
            setCustomSupTotalPlus(parseFloat((customSupTotal / 100).toFixed(2)));
            setBpp(
                Math.round(
                    ((curPackage.bartenderPrice - curPackage.bartenderCost) /
                        curPackage.bartenderCost) *
                    100 *
                    100
                ) / 100
            );
            // Replaced by the cocktail supplies breakdown effect (see cocktailSupplies below).
            // setSPP(
            //     Math.round(
            //         ((curPackage.suppliesPrice - curPackage.suppliesCost) /
            //             curPackage.suppliesCost) *
            //         100 *
            //         100
            //     ) / 100
            // );
            // if (curPackage.isTipPercentage) {
            //     setShowBtp(curPackage.isTipPercentage);
            //     setbtp((curPackage.tipsFee || 0) / 100);
            // } else {
            //     setShowBtp(curPackage.isTipPercentage);
            //     setBartenderTips((curPackage.tipsFee || 0) / 100);
            // }
            setPercentageTip((curPackage.tipsFee || 0) / 100);
            if (curPackage.minPrice > 0) {
                setMinPackagePrice(curPackage.minPrice / 100);
            } else {
                setMinPackagePrice(0);
            }
            setHrToRegister(curPackage.minHours);
            curPackage &&
                setSelectedSupplies([
                    ...curPackage.supplies.map(
                        (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
                    ),
                ]);
            if (curPackage.addons) {
                const addDefaultAddons = true;
                if (String(curPackage.type) === "custom_quote") {
                    setSupplyDescription(curPackage.description || "");
                } else if (addDefaultAddons) {
                    setSupplyDescription(
                        `${generateDescription(
                            selectedType === "custom_package" ? [] : curPackage.supplies
                        )}\n${generateAddsOnDescription([...curPackage.addons])}`
                    );
                } else {
                    data = curPackage.addons;
                    setSupplyDescription(
                        `${generateDescription(
                            selectedType === "custom_package" ? [] : curPackage.supplies
                        )}\n${generateAddsOnDescription([...data])}`
                    );
                }
                setAddOns(curPackage.addons);
            } else {
                setAddOns(defaultAddons);
            }
        } else {
            setAddOns(defaultAddons);
        }
    }, [curPackage]);


    const getPackageList = async (packageId?: string) => {
        try {
            const res = await GET(
                `${getRevnuePackage}/?business_id=${params ? businessId?.currentBusiness : business_id}`,
                refreshToken
            );
            if (res.data) {
                const visiblePackages = res?.data;
                const standardPackage =
                    visiblePackages.find((p: Package) => p.type === PackageType.Standard) ||
                    visiblePackages[0];
                // Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
                // const customQuotePackage = visiblePackages.find(
                //     (p: Package) => String(p.type) === "custom_quote"
                // );
                if (visiblePackages?.length === 0) {
                    setAddNewPackageForm(false);
                }
                setPackageList(visiblePackages);
                setLivePackageId(standardPackage?.id || "");
                // setCustomQuotePackageId(customQuotePackage?.id || "");
                // setCustomQuoteDescription(customQuotePackage?.description || "");
                if (packageId) {
                    const cur = visiblePackages.find((p: Package) => p.id === packageId);
                    setCurPackage(cur);
                } else {
                    setCurPackage(standardPackage);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    const deletePackage = async (packageId?: string) => {
        if (packageId) {
            try {
                setDeleteLoader(true);
                const res = await DELETE(`${packages}/${packageId}`, refreshToken);
                if (res.data) {
                    resetAddOnForm();
                    setAddOnIsEdit(false);
                    addNewPackagefn();
                    reset();
                    getPackageList();
                }
            } catch (error) {
                Alert({
                    type: "error",
                    message: "Error: Could not delete the selected package",
                });
                console.log(error);
            } finally {
                setDeleteLoader(false);
                setDeleteModal(false);
            }
        } else {
            Alert({
                type: "error",
                message: "Error: Could not delete the selected package",
            });
        }
    };

    const deliveryCostTotal = Number(deliveryCost);
    const deliveryPriceTotal = Number(deliveryCost);

    // Same distance + mileage rules as the client app, so the estimate matches checkout
    const eventDistance = useMemo(
        () =>
            businessAddress && eventAddress
                ? getStraightLineMiles(businessAddress, eventAddress)
                : null,
        [businessAddress, eventAddress]
    );
    const billableMiles =
        eventDistance !== null ? getBillableMiles(eventDistance, FREE_MILES) : 0;
    const mileageCharge =
        eventDistance !== null && maxDistance > FREE_MILES
            ? getMileageCharge(eventDistance, mileageFee, FREE_MILES)
            : 0;

    // Billed/priced in whole hours, same as QuoteBuilder (which ceils the start/end time
    // diff to whole hours), so a fractional selection here (e.g. 1.5) prices the same as
    // an actual quote for that event.
    const billableHours = Math.ceil(Number(hrToRegister));

    const estimatedTotals = useMemo(
        () =>
            calculateEstimatedTotals({
                guests: guest,
                hours: billableHours,
                drinker,
                guestsPerBartender: GPB ? selectedGuestBeer : selectedGuests,
                bartenderPrepTime,
                bartenderCost,
                // bartenderPrice / suppliesPrice state hold the markup, the util expects the full price
                bartenderPrice: Number(bartenderCost) + Number(bartenderPrice),
                suppliesCost: suppliesCosts,
                suppliesPrice: Number(suppliesCosts) + Number(suppliesPrice),
                // Mileage is billed like the delivery fee (charged to the customer and passed through as cost)
                deliveryFee: deliveryCostTotal + mileageCharge,
                additionalProfit,
                marketingExpense,
                insuranceExpense,
                otherExpense,
                minPackagePrice,
                addons: addOns,
                customSupplies: customSupplies || [],
                includeMandatoryPortableBar: mAddOnTotal,
                includeMandatoryIceAndCooler: mIceAndCoolerTotal,
                includeCustomSupplies: CST,
                includePaymentProcessingFee: CPF,
                paymentProcessingFeeRate: paymentProcessingFeeRate / 100,
                includeTips: bTips,
                tipPercentage: percentageTip,
                includeBeerAndWine,
            }),
        [
            guest,
            billableHours,
            drinker,
            GPB,
            selectedGuestBeer,
            selectedGuests,
            bartenderPrepTime,
            bartenderCost,
            bartenderPrice,
            suppliesCosts,
            suppliesPrice,
            deliveryCostTotal,
            mileageCharge,
            additionalProfit,
            marketingExpense,
            insuranceExpense,
            otherExpense,
            minPackagePrice,
            addOns,
            customSupplies,
            mAddOnTotal,
            mIceAndCoolerTotal,
            CST,
            CPF,
            paymentProcessingFeeRate,
            bTips,
            percentageTip,
            includeBeerAndWine,
        ]
    );
    const {
        numberOfBartenders,
        estimatedDrinks: estDrinksByDrinker,
        addOnTotal,
        addonsTotalCost,
        customSupplyTotal,
        customSupplyTotalCost,
        mandatoryPortableBarTotal: mandatoryAddOnsTotal,
        mandatoryIceAndCoolerTotal: mandatoryIceAndCooler,
        mandatoryPortableBarCost: mandatoryAddonsTotalCost,
        mandatoryIceAndCoolerCost,
        paymentProcessingFee: platFormTotal,
        tipsTotal: TipsTotal,
        minPriceEffect,
    } = estimatedTotals.breakdown;
    const { estimatedTotalRevenue, estimatedCost, estimatedProfit } = estimatedTotals;
    const {
        formState: { errors },
    } = useForm<PackageForm>({ defaultValues: { prepTime: 60 } });

    const deleteAddOn = (id: string) => {
        const updated = addOns.filter((item, index) => item.id !== id);
        setAddOns(updated);
        setSupplyDescription(
            `${generateDescription(selectedSupplies)}\n${generateAddsOnDescription([
                ...updated,
            ])}`
        );
    };
    const updatePackage = async () => {
        try {
            startLoading();
            const payload = {
                // minTips: customBartenderTip
                //     ? convertDollarToCents(customBartenderTip.toString())
                //     : 0,
                minTips: 0,
                bartenderCost: bartenderCost
                    ? convertDollarToCents(bartenderCost.toString())
                    : 0,
                bartenderPrice: convertDollarToCents(
                    (Number(bartenderPrice) + Number(bartenderCost)).toString()
                ),
                deliveryFee: deliveryCost
                    ? convertDollarToCents(deliveryCost.toString())
                    : 0,
                description: supplyDescription,
                startTime: curPackage?.startTime ?? "00:00:00",
                endTime: curPackage?.endTime ?? "24:00:00",
                image: curPackage?.image ?? "",
                isActive: activeStatus,
                radius: maxDistance ? Number(maxDistance) : 30,
                mileageFee: mileageFee
                    ? convertDollarToCents(mileageFee.toString())
                    : 0,
                minPrice: minPackagePrice
                    ? convertDollarToCents(minPackagePrice.toString())
                    : 0,
                bartenderPrepTime: bartenderPrepTime ? bartenderPrepTime : 0,
                name: curPackage?.name ?? "Instant Booking Cocktail Package",
                //    supply: selectedSupplies,
                suppliesCost: suppliesCosts
                    ? convertDollarToCents(suppliesCosts.toString())
                    : 0,
                suppliesFee: suppliesPrice
                    ? convertDollarToCents(suppliesPrice.toString())
                    : 0,
                hourToRegister: minPackageTime ? minPackageTime : 0,
                tips: !tipJar,
                // tipsFee: !tipJar
                //     ? showBtp
                //         ? convertDollarToCents(btp.toString())
                //         : convertDollarToCents(bartenderTips.toString())
                //     : 0,
                tipsFee: !tipJar
                    ? convertDollarToCents(percentageTip.toString())
                    : 0,
                guestPerBartender: selectedGuests ? selectedGuests : 0,
                type: curPackage?.type ?? selectedType,
                marketingExpense: Math.round(Number(marketingExpense) * 100),
                insuranceExpense: Math.round(Number(insuranceExpense) * 100),
                otherExpense: Math.round(Number(otherExpense) * 100),
                additionalProfit: Math.round(Number(additionalProfit) * 100),
                // isTipPercentage: showBtp,
                isTipPercentage: true,
                packageAddons: addOns.map((item: any) => {
                    return {
                        id: item.id,
                        name: item.name,
                        auto_include: item.auto_include,
                        price: formatNumber(item.price),
                        cost: formatNumber(item.cost),
                        type: item.type,
                        description: item.description,
                        addonImage: item.image ? item.image : item.addonImage,
                    };
                }),
                business_id: curPackage?.businessId || businessId.currentBusiness || business_id,
            };
            if (bartenderCost <= 0) {
                Alert({ type: "error", message: "Bartender Price cannot be zero" });
                stopLoading();
                return;
            }
            if (selectedType !== "custom_package" && suppliesCosts <= 0) {
                Alert({ type: "error", message: "Cocktail Price cannot be zero" });
                stopLoading();
                return;
            }
            // if (Number(suppliesCosts) + Number(suppliesPrice) <= 0) {
            //   Alert({ type: "error", message: "Cocktail Price cannot be zero" });
            //   stopLoading();
            //   return;
            // }
            // if (selectedSupplies.length === 0 && selectedType !== "custom_package") {
            //     Alert({ type: "error", message: "Supplies required" });
            //     stopLoading();
            //     return false;
            // }
            if (deliveryCost <= 0) {
                Alert({ type: "error", message: "Fixed Expense required" });
                stopLoading();
                return false;
            }
            if (maxDistance > 30 && mileageFee <= 0) {
                Alert({ type: "error", message: "Cost per mile is required" });
                stopLoading();
                return false;
            }
            // if (
            //   !tipJar &&
            //   ((showBtp && btp < 0) || (!showBtp && bartenderTips <= 0))
            // ) {
            //   Alert({
            //     type: "error",
            //     message: "Tips Required",
            //   });
            //   stopLoading();
            //   return false;
            // }
            const formData = new FormData();
            const appendToFormData = (payload: Record<string, any>) => {
                for (const key in payload) {
                    if (Object.prototype.hasOwnProperty.call(payload, key)) {
                        if (key === "packageAddons") {
                            // Handle nested array (packageAddons) separately
                            // payload[key].forEach((addon: any, index: number) => {
                            //   console.log('append',addon)
                            //   // formData.append(`packageAddons[${index}][id]`, addon.id);
                            //   formData.append(`packageAddons[${index}][name]`, addon.name);
                            //   formData.append(
                            //     `packageAddons[${index}][auto_include]`,
                            //     addon.auto_include
                            //   );
                            //   formData.append(`packageAddons[${index}][price]`, addon.price);
                            //   formData.append(`packageAddons[${index}][cost]`, addon.cost);
                            //   formData.append(`packageAddons[${index}][type]`, addon.type);
                            //   formData.append(
                            //     `packageAddons[${index}][description]`,
                            //     addon.description
                            //   );
                            //   if (addon.addonImage && addon.addonImage.file) {
                            //     formData.append(
                            //       `packageAddons[${index}][addonImage]`,
                            //       addon.addonImage.file
                            //     );
                            //   } else {
                            //     formData.append(
                            //       `packageAddons[${index}][addonImage]`,
                            //       addon.img
                            //     );
                            //   }
                            // });
                        } else if (key === "image" && payload[key]) {
                            // Handle file (image)
                            formData.append(key, payload[key] as Blob);
                        } else if (key === "supply") {
                            payload[key].forEach((item: string, index: number) => {
                                formData.append(`supply[${index}]`, item);
                            });
                        } else {
                            // Append other fields
                            formData.append(key, String(payload[key]));
                        }
                    }
                }
            };
            // append addons
            addOns.forEach((addon: any, index: number) => {
                formData.append(`packageAddons[${index}][id]`, addon.id);
                formData.append(`packageAddons[${index}][name]`, addon.name);
                formData.append(
                    `packageAddons[${index}][auto_include]`,
                    addon.auto_include
                );
                formData.append(`packageAddons[${index}][price]`, addon.price);
                formData.append(`packageAddons[${index}][cost]`, addon.cost);
                formData.append(`packageAddons[${index}][type]`, addon.type);
                formData.append(`packageAddons[${index}][min_price]`, addon.min_price);
                formData.append(
                    `packageAddons[${index}][include_prep_time]`,
                    addon.include_prep_time
                );
                addon.is_btc_edit !== undefined &&
                    formData.append(
                        `packageAddons[${index}][is_btc_edit]`,
                        addon.is_btc_edit
                    );
                formData.append(
                    `packageAddons[${index}][description]`,
                    addon.description
                );
                if (addon.addonImage && addon.addonImage.file) {
                    formData.append(
                        `packageAddons[${index}][addonImage]`,
                        addon.addonImage.file
                    );
                } else {
                    formData.append(`packageAddons[${index}][addonImage]`, addon.img);
                }
            });
            // Previously this whole forEach (plus the guestsPerBeer append below)
            // was gated behind `if (selectedType === "custom_package") { ... }`.
            // Custom supply breakdown (mixers, straws, garnishes, cups, napkins, etc.)
            // is now submitted for every package type so the cocktail breakdown persists.
            customSupplies?.forEach((item, index) => {
                formData.append(`customSupply[${index}][name]`, item?.name as string);
                formData.append(
                    `customSupply[${index}][image]`,
                    item?.image as string
                );
                formData.append(`customSupply[${index}][type]`, item?.type as string);
                formData.append(
                    `customSupply[${index}][cost]`,
                    Math.round(item?.cost)?.toString() as string
                );
                formData.append(
                    `customSupply[${index}][profit]`,
                    Math.round(item?.profit)?.toString() as string
                );
                // formData.append(`customSupply[${index}][image]`, item?.file as File);
                formData.append(
                    `customSupply[${index}][description]`,
                    item?.description as string
                );
                formData.append(
                    `customSupply[${index}][isBeer]`,
                    JSON.stringify(item?.isBeer) as string
                );
                formData.append(
                    `customSupply[${index}][isCocktail]`,
                    JSON.stringify(item?.isCocktail) as string
                );
                formData.append(
                    `customSupply[${index}][isWine]`,
                    JSON.stringify(item?.isWine) as string
                );
                formData.append(
                    `customSupply[${index}][byCustomer]`,
                    JSON.stringify(item?.byCustomer) as string
                );
                curPackage &&
                    curPackage.id &&
                    formData.append(`customSupply[${index}][id]`, item?.id as string);
            });
            if (selectedType === "custom_package") {
                formData.append("guestsPerBeer", selectedGuestBeer.toString());
            }

            appendToFormData(payload);
            for (const pair of formData.entries()) {
                console.log(pair[0] + ": " + pair[1]);
            }
            if (curPackage?.id) {
                const res = await PATCH(
                    singlePackageApi + `/${curPackage?.id}`,
                    formData,
                    refreshToken
                );
                if (res.data.success) {
                    Alert({ type: "success", message: res?.data?.message });
                    stopLoading();
                    params?.isCompanyCreation && params.next && params?.next();
                } else {
                    stopLoading();
                    Alert({ type: "error", message: res?.data?.message });
                }
            } else {
                const res = await POST_MULTIPART(addPackageApi, formData, refreshToken);
                console.log(res);
                if (res.data.success) {
                    setModal(false);
                    getPackageList(res.data?.packageId);
                    Alert({ type: "success", message: res?.data?.message });
                    stopLoading();
                    params?.isCompanyCreation && params.next && params?.next();
                } else {
                    setModal(false);
                    stopLoading();
                    Alert({ type: "error", message: res?.data?.message });
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            stopLoading();
        }
    };
    // Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
    // const updateCustomQuoteDescriptionOnly = async () => {
    //     if (!customQuotePackageId) return;
    //     try {
    //         setIsCustomQuoteUpdating(true);
    //         const endpoint = updateCustomQuoteDescription.replace(":id", customQuotePackageId);
    //         const res = await PATCH(
    //             endpoint,
    //             { description: customQuoteDescription },
    //             refreshToken
    //         );
    //         if (res?.data?.success) {
    //             Alert({ type: "success", message: res?.data?.message });
    //         } else {
    //             Alert({ type: "error", message: res?.data?.message });
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         Alert({ type: "error", message: "Failed to update custom quote description" });
    //     } finally {
    //         setIsCustomQuoteUpdating(false);
    //     }
    // };
    const addNewPackagefn = async () => {
        const isValid = await trigger("packageName");
        const newPackageObj: Package = {
            is_active: false,
            guests_per_bartender: 25,
            // guestsPerCocktail: 25,
            guestsPerBeer: 25,
            additionalProfit: 0,
            addons: defaultAddons.map((_) => ({
                ..._,
                auto_include: selectedType === "custom_package" ? false : _.auto_include,
            })) as any,
            bartenderCost: 0,
            bartenderPrice: 0,
            minTips: 0,
            businessId: businessId.currentBusiness || "",
            createdAt: "",
            deliveryFee: 0,
            description: "",
            endTime: "24:00:00",
            guestsPerBartender: 25,
            id: "",
            image: "",
            insuranceExpense: 0,
            otherExpense: 0,
            isActive: true,
            marketingExpense: 0,
            mileageFee: 0,
            radius: 30,
            minHours: 3,
            minPrice: 0,
            name: watch("packageName"),
            prepMins: 60,
            startTime: "00:00:00",
            supplies: [],
            suppliesCost: 0,
            suppliesPrice: 0,
            tipsFee: 0,
            tipsOptional: true,
            type: selectedType as PackageType,
            updatedAt: "",
            isTipPercentage: true,
        };
        if (isValid) {
            if (params?.isCompanyCreation) {
                if (curPackage && curPackage.id) {
                    setAddNewPackageForm(false);
                    const newPackageObj: Package = {
                        is_active: false,
                        guests_per_bartender: 25,
                        // guestsPerCocktail: 25,
                        guestsPerBeer: 25,
                        additionalProfit: 0,
                        addons: [],
                        bartenderCost: 0,
                        bartenderPrice: 0,
                        businessId: businessId.currentBusiness || "",
                        createdAt: "",
                        deliveryFee: 0,
                        description: "",
                        endTime: "24:00:00",
                        guestsPerBartender: 25,
                        id: "",
                        image: "",
                        insuranceExpense: 0,
                        otherExpense: 0,
                        isActive: true,
                        marketingExpense: 0,
                        mileageFee: 0,
                        radius: 30,
                        minHours: 3,
                        minPrice: 0,
                        name: watch("packageName"),
                        prepMins: 60,
                        startTime: "00:00:00",
                        supplies: [],
                        suppliesCost: 0,
                        suppliesPrice: 0,
                        tipsFee: 0,
                        tipsOptional: false,
                        isTipPercentage: false,
                        type: selectedType as PackageType,
                        updatedAt: "",
                        minTips: 0,
                    };
                    setPackageList([...packageList, newPackageObj]);
                    setCurPackage(newPackageObj);
                } else {
                    const newObject: any = {
                        ...newPackageObj,
                        name: watch("packageName"),
                    };
                    setCurPackage(newObject);
                    setPackageList((prev) => [
                        ...prev.filter((item) => item?.id !== ""),
                        newObject,
                    ]);
                    setPackageFormEditForm(false);
                    setAddNewPackageForm(false);
                    return;
                }
            }
            if (curPackage && curPackage.id && packageFormEditForm) {
                const newObject: any = {
                    ...curPackage,
                    name: watch("packageName"),
                    type: selectedType as PackageType,
                    isActive: activeStatus,
                };
                setCurPackage(newObject);
                setPackageList((prev) => [
                    ...prev.filter((item) => item?.id !== curPackage.id),
                    newObject,
                ]);
            } else {
                const newObject: any = {
                    ...newPackageObj,
                    name: watch("packageName"),
                };
                setCurPackage(newObject);
                setPackageList((prev) => [
                    ...prev.filter((item) => item?.id !== ""),
                    newObject,
                ]);
            }
            setPackageFormEditForm(false);
            setAddNewPackageForm(false);
        }
    };
    const addAddOn = () => {
        dispatch(formStateChange(true));
        if (addOnName == "") {
            setAddOnError("Name is required");
            return;
        }
        if (
            addOnCost == "" ||
            parseInt(addOnCost) < 0 ||
            parseInt(addOnCost) > 999
        ) {
            setAddOnError("Enter valid cost (0-999)");
            return;
        }
        const intCost = parseFloat(addOnCost).toFixed(2);
        const intMinPrice = parseFloat(addOnMinPrice).toFixed(2);
        setAddOnError("");
        const addonsPriceInteger = addOnPrice
            ? parseFloat(parseFloat(addOnPrice).toFixed(2))
            : 0;
        const date = new Date();
        const obj = {
            id: date.toString(),
            name: addOnName,
            type: addOnType,
            price: parseFloat(
                (addonsPriceInteger * 100 + parseFloat(intCost) * 100).toFixed(2)
            ),
            // price:parseFloat(( addonsPriceInteger * 100 + parseFloat(addOnCost) * 100).toFixed(2)),
            cost: parseFloat((parseFloat(intCost) * 100).toFixed(2)),
            description: addOnDesc,
            addonImage: addOnImage?.file ? addOnImage : undefined,
            auto_include: includeInPackage,
            include_prep_time: addOnPrepTime,
            img: !addOnImage?.file ? defaultAddonImg : "",
            is_btc_edit: true,
            min_price: parseFloat((parseFloat(intMinPrice) * 100).toFixed(2)) || 0,
        };
        setAddOns([...addOns, obj]);
        setSupplyDescription(
            generateDescription(selectedSupplies) +
            "\n" +
            generateAddsOnDescription([...addOns, obj])
        );
        setAddOnForm(false);
        setAddOnName("");
        setAddOnType("bartender");
        setAddOnPrice("");
        setAddOnCost("");
        setAddOnMinPrice("");
        setAddOnDesc("");
        setAddOnImage({ img: "" });
        setIncludeInPackage(false);
        setAddOnPrepTime(false);
    };
    const updateAddOn = () => {
        dispatch(formStateChange(true));
        const intCost = addOnCost ? parseFloat(addOnCost).toFixed(2) : 0;
        const intMinPrice = addOnPrice ? parseFloat(addOnMinPrice).toFixed(2) : 0;
        // const intCost = parseFloat(addOnCost)
        // check for default if the update item is default
        let isDefualt = false;
        addOns.map((_) => {
            if (_.id === addOnId) {
                console.log("matched", _);
                isDefualt = _.is_btc_edit || false;
            }
            return _;
        });
        const filteredAddOn = addOns.filter((item: any) => item.id !== addOnId);
        // In case user update the image of add on
        // const addonsPriceInteger = addOnPrice ? parseFloat(addOnPrice) : 0;
        const addonsPriceInteger = addOnPrice
            ? parseFloat(parseFloat(addOnPrice).toFixed(2))
            : 0;
        const date = new Date();
        let updatedAddons = [];
        if (addOnImage?.file) {
            updatedAddons = [
                ...filteredAddOn,
                {
                    id: addOnId,
                    name: addOnName,
                    price: parseFloat(
                        (addonsPriceInteger * 100 + Number(intCost) * 100).toFixed(2)
                    ),
                    cost: Number(intCost) * 100,
                    addonImage: { ...addOnImage, file: addOnImage.file },
                    description: addOnDesc,
                    auto_include: includeInPackage,
                    include_prep_time: addOnPrepTime,
                    type: addOnType,
                    is_btc_edit: isDefualt,
                    min_price: Number(intMinPrice) * 100,
                },
            ];
        } else {
            updatedAddons = [
                ...filteredAddOn,
                {
                    id: addOnId,
                    name: addOnName,
                    price: parseFloat(
                        (addonsPriceInteger * 100 + Number(intCost) * 100).toFixed(2)
                    ),
                    cost: Number(intCost) * 100,
                    img: addOnImage?.img,
                    description: addOnDesc,
                    auto_include: includeInPackage,
                    include_prep_time: addOnPrepTime,
                    type: addOnType,
                    is_btc_edit: isDefualt,
                    min_price: Number(intMinPrice) * 100,
                },
            ];
        }
        setAddOns(updatedAddons);
        setAddOnForm(false);
        setAddOnIsEdit(false);
        resetAddOnForm();
        setSupplyDescription(
            generateDescription(selectedSupplies) +
            "\n" +
            generateAddsOnDescription(updatedAddons)
        );
    };
    const editAddonForm = (item: any) => {
        dispatch(formStateChange(true));
        const {
            name,
            img,
            price,
            type,
            id,
            description,
            auto_include,
            cost,
            addonImage,
            is_btc_edit,
            min_price,
            include_prep_time,
        } = item;
        // if form is open edit mod;
        if (!addAddOnForm) {
            console.log("min_price--------------->", min_price, cost);
            setAddOnId(id);
            addonImage ? setAddOnImage(addonImage) : setAddOnImage({ img });
            setAddOnName(name);
            setAddOnPrice(((price - cost) / 100).toString());
            setAddOnCost((cost / 100).toString());
            setAddOnMinPrice((min_price / 100).toString());
            setAddOnPrepTime(include_prep_time);
            setAddOnType(type);
            setIncludeInPackage(auto_include);
            setAddOnDesc(description);
            setAddOnIsEdit(true);
            setIsEditByBtC(is_btc_edit);
        } else {
            resetAddOnForm();
            setAddOnIsEdit(false);
        }
        setAddOnForm(!addAddOnForm);
    };
    const resetAddOnForm = () => {
        setAddOnName("");
        setAddOnDesc("");
        setAddOnPrice("");
        setAddOnCost("");
        setAddOnMinPrice("");
        setAddOnType("bartender");
        setIncludeInPackage(false);
        setAddOnPrepTime(false);
        setAddOnImage({ img: "" });
        setIsEditByBtC(true);
    };
    const uploadAddOnImg = (file: any) => {
        dispatch(formStateChange(true));
        console.log(file);
        try {
            const f = ImageUploadFunDropZone(file);
            if (f) {
                setAddOnImage({ img: URL.createObjectURL(f), file: f });
                // setCustomError("dp", "");
            }
        } catch (error: any) {
            console.log("error", error.message);
            setCustomError("dp", error.message);
        }
    };
    const removeAddOnImage = () => {
        setAddOnImage({ img: "" });
    };
    const selectSupply = (checked: boolean, name: string) => {
        setSelectedSupplies((prev) => {
            const updatedSupplies = checked
                ? prev.filter((s) => s !== name) // Remove if checked
                : [...prev, name]; // Add if unchecked

            setSupplyDescription(
                `${generateDescription(updatedSupplies)}\n${generateAddsOnDescription([
                    ...addOns,
                ])}`
            );
            return updatedSupplies;
        });
    };
    const generateDescription = (supplies: string[]) => {
        if (supplies.length === 0) {
            return "";
        }
        const supply = `Includes:\n→ ${supplies.join("\n→ ")}`;
        return supply;
    };
    const generateCustomSupplyDesc = (customSupplies: string[]) => {
        if (customSupplies.length === 0) {
            return "";
        }
        const supply = `Custom Supplies:\n→ ${customSupplies.join("\n→ ")}`;
        return supply;
    };
    const generateAddsOnDescription = (array: AddOnsCalInterface[]) => {
        //generates a description from the array of add ons
        console.log("arrays", array);
        if (array.length == 0) {
            return "";
        }
        const included = array
            .filter((item: any) => {
                if (item.auto_include) {
                    return item.name;
                }
            })
            .map((item) => item.name);
        const exclded = array
            .filter((item: any) => {
                if (!item.auto_include) {
                    return item.name;
                }
            })
            .map((item) => item.name);
        return `${exclded.length > 0
            ? `Add-ons (for an additional charge):
  → ${exclded.join("\n→ ")}`
            : ""
            }
  ${included.length > 0
                ? `Add-ons (Included):
  → ${included.join("\n→ ")}`
                : ""
            }
  `;
    };
    const addNewSupplyTab = () => {
        if (supplyInput) {
            setTotalSuppliesList((prev) => [...prev, supplyInput]);
            setAddSupplyForm(false);
        } else {
            setAddError("Supply name cannot be empty.");
        }
    };
    useEffect(() => {
        if (selectedType === "custom_package") {
            setSelectedSupplies([]);
            // setAddOns(addOns.map((i) => {
            //   if (i.name === iceCubes || i.name === portableBar) {
            //     i.auto_include = false
            //   }
            //   return i
            // }))
            // // changing auto include status
            // setAddOns(addOns.map((i) => {
            //   if (i.name === iceCubes || i.name === portableBar) {
            //     i.auto_include = false
            //   }
            //   return i
            // }))
        } else if (selectedType !== "custom_package") {
            // populate supplies
            curPackage &&
                setSelectedSupplies([
                    ...curPackage.supplies.map(
                        (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
                    ),
                ]);
            // setCanSubmit(true)
            // setAddOns(addOns.map((i) => {
            //   if (i.name === iceCubes || i.name === portableBar) {
            //     i.auto_include = true
            //   }
            //   return i
            // }))
            // // changing auto include status
            // setAddOns(addOns.map((i) => {
            //   if (i.name === iceCubes || i.name === portableBar) {
            //     i.auto_include = true
            //   }
            //   return i
            // }))
            getGarnishes();
        } else {
            setValue("packageName", "");
        }
        curPackage &&
            setSupplyDescription(
                selectedType === "custom_quote"
                    ? curPackage.description || ""
                    : `${generateDescription(
                        selectedType === "custom_package" ? [] : curPackage.supplies
                    )}\n${generateAddsOnDescription(addOns)}`
            );
        if (selectedType != "custom_package") {
            setCST(false);
        }
        // if (selectedType == 'custom_package') {
        //   setMinPackagePrice(0)
        // }
    }, [selectedType]);
    useEffect(() => {
        // Get default supploes
        const getDefaultSupplies = async () => {
            try {
                const res = await GET(packageDefaultSupplies, refreshToken);
                // setCustomSupplies(res.data)
                setCustomSupplies(
                    res.data.map((i: CustomSupply) => {
                        i.profit = i?.price - i?.cost;
                        // i.price = parseFloat((i.price/100).toFixed(2))
                        return i;
                    })
                );
            } catch (error) {
                console.log(error);
            }
        };
        // Previously only fetched for custom_package:
        //  selectedType === 'custom_package' &&  getDefaultSupplies()
        // selectedType === "custom_package" &&
        //     !curPackage?.customSupply &&
        //     getDefaultSupplies();
        // Now: seed with global default supplies whenever this package has no
        // per-package breakdown saved yet, regardless of package type.
        !curPackage?.customSupply?.length && getDefaultSupplies();
    }, [selectedType, curPackage?.id]);
    const editDefaultSupplyPrice = (
        e: React.FocusEvent<HTMLInputElement>,
        id: string,
        type: "cost" | "profit" | "isActive"
    ) => {
        let validate = true;

        // Blank/invalid input counts as 0; clamp to max 999 and store whole cents
        // so the per-cocktail total always equals the displayed cost + profit.
        const parsed = parseFloat(e.target.value);
        const cents = Math.round((isNaN(parsed) ? 0 : Math.min(parsed, 999)) * 100);

        const filtered = customSupplies?.map((current) => {
            if (current.id !== id) return current;
            const item = { ...current };
            if (type === "cost") {
                item.cost = cents;
                item.price = item.cost + item.profit;
            } else if (type === "profit") {
                item.profit = cents;
                item.price = item.cost + item.profit;
            } else if (type === "isActive") {
                item.isActive = !item?.isActive;
            }

            // validation logic
            if (
                isNaN(item.cost) ||
                isNaN(item.profit) ||
                item.profit < 0 // disallow negative profit
            ) {
                // setCanSubmit(false);
                validate = false;
            }

            return item;
        });

        // setCanSubmit(validate);
        if (filtered) {
            setCustomSupplies(filtered);

            const totalPrice = filtered.reduce((sum, item) => {
                return sum + (item.price || 0);
            }, 0);

            // convert cents to dollars if needed
            setCustomSupTotalPlus(parseFloat((totalPrice / 100).toFixed(2)));
        }
    };

    // Cocktail-specific supplies (mixers, straws, garnishes, cups, napkins, etc.)
    // drive the "About your Cocktails" price breakdown for non-custom packages.
    const cocktailSupplies = useMemo(
        () => customSupplies?.filter((item) => item.isCocktail) ?? [],
        [customSupplies]
    );
    const cocktailSuppliesTotal = useMemo(
        () =>
            parseFloat(
                (
                    cocktailSupplies.reduce(
                        (sum, item) => sum + (item.cost || 0) + (item.profit || 0),
                        0
                    ) /
                    100
                ).toFixed(2)
            ),
        [cocktailSupplies]
    );
    useEffect(() => {
        if (selectedType === "custom_package") return;
        const totals = cocktailSupplies.reduce(
            (acc, item) => {
                acc.cost += item.cost || 0;
                acc.profit += item.profit || 0;
                return acc;
            },
            { cost: 0, profit: 0 }
        );
        setSuppliesCosts(parseFloat((totals.cost / 100).toFixed(2)));
        setSuppliesPrice(parseFloat((totals.profit / 100).toFixed(2)));
    }, [cocktailSupplies, selectedType]);

    const bartenderCostField = useDecimalField(bartenderCost, setBartenderCost, 999);
    const bartenderPriceField = useDecimalField(bartenderPrice, setBartenderPrice, 999);
    const bppField = useDecimalField(
        Bpp,
        (floatVal) => {
            const clamped = floatVal > 100 ? 100 : floatVal;
            setBpp(clamped);
            setBartenderPrice((bartenderCost * clamped) / 100);
        },
        100
    );
    // Replaced by the cocktail supplies breakdown table — suppliesCosts/suppliesPrice
    // are now derived automatically instead of being typed in directly.
    // const suppliesCostsField = useDecimalField(suppliesCosts, setSuppliesCosts, 999);
    // const suppliesPriceField = useDecimalField(suppliesPrice, setSuppliesPrice, 999);
    // const sppField = useDecimalField(
    //     SPP,
    //     (floatVal) => {
    //         const clamped = floatVal > 100 ? 100 : floatVal;
    //         setSPP(clamped);
    //         setSuppliesPrice((suppliesCosts * clamped) / 100);
    //     },
    //     100
    // );
    const additionalProfitField = useDecimalField(additionalProfit, setAdditionalProfit, 5000);
    const minPackagePriceField = useDecimalField(
        minPackagePrice,
        (floatVal) => {
            setHrToRegister(1);
            setMinPackagePrice(floatVal);
        },
        5000
    );
    // const customBartenderTipField = useDecimalField(customBartenderTip, setCustomBartenderTip, 5000);
    const percentageTipField = useDecimalField(percentageTip, setPercentageTip, 100);
    const paymentProcessingFeeField = useDecimalField(
        paymentProcessingFeeRate,
        setPaymentProcessingFeeRate,
        100
    );
    const deliveryCostField = useDecimalField(deliveryCost, setDeliveryCost, 5000);
    const mileageFeeField = useDecimalField(mileageFee, setMileageFee, 999);
    const insuranceExpenseField = useDecimalField(insuranceExpense, setInsuranceExpense, 5000);
    const marketingExpenseField = useDecimalField(marketingExpense, setMarketingExpense, 5000);
    const otherExpenseField = useDecimalField(otherExpense, setOtherExpense, 5000);

    return (
        <div>
            <div className="relative">
                <div className="flex flex-col gap-1">
                    <DashboardHeader title="Pricing Calculator"></DashboardHeader>
                    {/* {businessName ? (
                        <p className="text-sm font-medium text-gray-600 -mt-2 mb-0 pl-0.5">
                            {businessName}
                        </p>
                    ) : null} */}
                    {/* <img
            onClick={resetCalulator}
            src={refreshImg}
            className="transition-all hover:rotate-45  w-7 cursor-pointer"
            alt="refresh"
          /> */}
                </div>
                <div className=" top-0 w-full pt-4 pb-4  z-10 shadow-primary-gray gap-7">
                    <div className=" flex md:flex-row flex-wrap  w-full justify-start gap-5  mx-2 items-stretch ">
                        <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
                            <div>
                                <div className="flex items-center justify-between gap-2">
                                    <p className=" font-semibold ">Total Revenue</p>
                                    <button
                                        type="button"
                                        data-tooltip-id="watch-video-tooltip"
                                        onClick={() =>
                                            openVideoModal(
                                                "Total Revenue",
                                                SECTION_HELP_VIDEOS.estimatedRevenue
                                            )
                                        }
                                        className="flex items-center text-primary-red cursor-pointer shrink-0"
                                    >
                                        <FaCirclePlay size={18} />
                                    </button>
                                </div>
                                <p className="font-semibold text-3xl mb-2 mt-1">
                                    ${`${USFormatePriceWithDecimal(estimatedTotalRevenue)}`}
                                </p>
                            </div>
                            <div className="flex flex-col gap-1 ">
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold ">Bartending Price: </p>
                                        {/* <ToggleInput
                      checked={BP}
                      onChange={() => {
                        setBP(!BP);
                      }}
                    /> */}
                                    </div>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            (Number(bartenderCost) + Number(bartenderPrice)) *
                                            Number(numberOfBartenders) *
                                            (Number(billableHours) + Number(bartenderPrepTime) / 60)
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold ">Cocktails Price: </p>
                                        {/* <ToggleInput
                      checked={CP}
                      onChange={() => {
                        setCP(!CP);
                      }}
                    /> */}
                                    </div>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            (Number(suppliesCosts) + Number(suppliesPrice)) *
                                            Number(estDrinksByDrinker)
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Additional Profit:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(Number(additionalProfit))}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Add-ons Total:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(addOnTotal)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Fixed Expense:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(deliveryPriceTotal)}
                                    </p>
                                </div>
                                {mileageCharge > 0 && (
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Mileage:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(mileageCharge)}
                                        </p>
                                    </div>
                                )}
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Min Price Effect:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(minPriceEffect)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Insurance Expense:</p>
                                    <p className="text-xs font-semibold">
                                        {" "}
                                        ${USFormatePriceWithDecimal(insuranceExpense)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Marketing Expense:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(marketingExpense)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Other Expense:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(otherExpense)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold">Gratuity:</p>
                                        <ToggleInput
                                            checked={bTips}
                                            onChange={() => {
                                                setBTips(!bTips);
                                            }}
                                        />
                                    </div>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(TipsTotal)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold">
                                            Payment Processing Fee:
                                        </p>
                                        {/* Payment processing fee is always applied (enabled by default)
                                        <ToggleInput
                                            checked={CPF}
                                            onChange={() => {
                                                setCPF(!CPF);
                                            }}
                                        /> */}
                                    </div>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            isNaN(platFormTotal) ? 0 : platFormTotal
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold">
                                            Mandatory Portable Bar:
                                        </p>
                                        <ToggleInput
                                            checked={mAddOnTotal}
                                            onChange={() => {
                                                setMaddOnTotal(!mAddOnTotal);
                                            }}
                                        />
                                    </div>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            isNaN(mandatoryAddOnsTotal) ? 0 : mandatoryAddOnsTotal
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-2 mb-[-8px]">
                                        <p className="text-xs font-semibold">
                                            Mandatory Ice and Cooler:
                                        </p>
                                        <ToggleInput
                                            checked={mIceAndCoolerTotal}
                                            onChange={() => {
                                                setmIceAndCoolerTotal(!mIceAndCoolerTotal);
                                            }}
                                        />
                                    </div>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            isNaN(mandatoryIceAndCooler) ? 0 : mandatoryIceAndCooler
                                        )}
                                    </p>
                                </div>
                                {selectedType == "custom_package" && (
                                    <div className="flex justify-between">
                                        <div className="flex flex-row gap-2">
                                            <p className="text-xs font-semibold">
                                                Custom Supply Total
                                            </p>
                                            <ToggleInput
                                                checked={CST}
                                                onChange={() => {
                                                    setCST(!CST);
                                                }}
                                            />
                                        </div>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(customSupplyTotal)}
                                        </p>
                                    </div>
                                )}

                                {/* <p className="text-xs font-semibold">
                  Tip Revenue: {tipTotal}
                </p> */}
                            </div>
                        </div>
                        <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
                            <div className="">
                                <p className=" font-semibold">Estimated Expenses</p>
                                <p className="font-semibold text-3xl mb-2 mt-1">
                                    ${`${USFormatePriceWithDecimal(estimatedCost)}`}
                                </p>
                            </div>
                            <div>
                                <div className="flex flex-col gap-1 ">
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Bartending Cost: </p>
                                        <p className="text-xs font-semibold">
                                            $
                                            {USFormatePriceWithDecimal(
                                                bartenderCost *
                                                numberOfBartenders *
                                                (Number(billableHours) +
                                                    Number(bartenderPrepTime) / 60)
                                            )}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Cocktail Cost: </p>
                                        <p className="text-xs font-semibold">
                                            $
                                            {USFormatePriceWithDecimal(
                                                suppliesCosts * estDrinksByDrinker
                                            )}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Platform Fee:</p>
                                        <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Add-ons Cost:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(addonsTotalCost)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Fixed Expense:</p>

                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(deliveryPriceTotal)}
                                        </p>
                                    </div>
                                    {mileageCharge > 0 && (
                                        <div className="flex justify-between">
                                            <p className="text-xs font-semibold">Mileage:</p>
                                            <p className="text-xs font-semibold">
                                                ${USFormatePriceWithDecimal(mileageCharge)}
                                            </p>
                                        </div>
                                    )}
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Min Price Effect:</p>

                                        <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Insurance Expense:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(insuranceExpense)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Marketing Expense:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(marketingExpense)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Other Expense:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(otherExpense)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">Gratuity:</p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(TipsTotal)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">
                                            Payment Processing Fee:
                                        </p>
                                        <p className="text-xs font-semibold">
                                            $
                                            {USFormatePriceWithDecimal(
                                                isNaN(platFormTotal) ? 0 : platFormTotal
                                            )}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">
                                            Mandatory Portable Bar Cost:
                                        </p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(mandatoryAddonsTotalCost)}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">
                                            Mandatory Ice and Cooler Cost:
                                        </p>
                                        <p className="text-xs font-semibold">
                                            ${USFormatePriceWithDecimal(mandatoryIceAndCoolerCost)}
                                        </p>
                                    </div>
                                    {selectedType == "custom_package" && (
                                        <div className="flex justify-between">
                                            <p className="text-xs font-semibold">
                                                Custom Supply Total
                                            </p>
                                            <p className="text-xs font-semibold">
                                                ${USFormatePriceWithDecimal(customSupplyTotalCost)}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
                            <div>
                                <p className=" font-semibold ">Estimated Profit</p>
                                <p className="font-semibold text-3xl mt-1 mb-2">
                                    ${`${USFormatePriceWithDecimal(estimatedProfit)}`}
                                </p>
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Bartending Service Profit:{" "}
                                    </p>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            bartenderPrice *
                                            numberOfBartenders *
                                            (Number(billableHours) + Number(bartenderPrepTime) / 60)
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Profit from Cocktails:{" "}
                                    </p>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            suppliesPrice * estDrinksByDrinker
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Additional Profit - Platform Fee:{" "}
                                    </p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(additionalProfit)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Add-ons Profit:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(addOnTotal - addonsTotalCost)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Fixed Expense:</p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Min Price Effect:</p>
                                    <p className="text-xs font-semibold">
                                        ${USFormatePriceWithDecimal(minPriceEffect)}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Insurance Expense:</p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Marketing Expense:</p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Other Expense:</p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">Gratuity:</p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Payment Processing Fee:
                                    </p>
                                    <p className="text-xs font-semibold">${(0).toFixed(2)}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Mandatory Portable Bar Profit:
                                    </p>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            mandatoryAddOnsTotal - mandatoryAddonsTotalCost
                                        )}
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="text-xs font-semibold">
                                        Mandatory Ice and Cooler Profit:
                                    </p>
                                    <p className="text-xs font-semibold">
                                        $
                                        {USFormatePriceWithDecimal(
                                            mandatoryIceAndCooler - mandatoryIceAndCoolerCost
                                        )}
                                    </p>
                                </div>
                                {selectedType == "custom_package" && (
                                    <div className="flex justify-between">
                                        <p className="text-xs font-semibold">
                                            Custom Supply Total:
                                        </p>
                                        <p className="text-xs font-semibold">
                                            {" "}
                                            $
                                            {USFormatePriceWithDecimal(
                                                customSupplyTotal - customSupplyTotalCost
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white w-full rounded-2xl p-5">
                    <div className="flex items-center gap-3 mb-4">
                        <DrinkRow
                            value={drinker}
                            onChange={setDrinker}
                            estDrinks={estDrinksByDrinker}
                            onEstDrinksChange={() => undefined}
                            disableEstDrink
                            hideDrinkerLabel={true}
                            className="flex-1"
                        />
                        <button
                            type="button"
                            data-tooltip-id="watch-video-tooltip"
                            onClick={() =>
                                openVideoModal(
                                    "Price Calculator",
                                    SECTION_HELP_VIDEOS.priceCalculator
                                )
                            }
                            className="flex items-center text-primary-red cursor-pointer shrink-0"
                        >
                            <FaCirclePlay size={18} />
                        </button>
                    </div>
                    <div className="flex md:flex-row flex-col items-center gap-4">
                        {/* <div className="flex flex-row ">
                            <div className="w-full flex justify-center flex-row gap-4 items-center">
                                <div className="w-full h-72 flex justify-center items-center">
                                    <PieChart
                                        Profit={profit as number}
                                        Revenue={Revenue as number}
                                        Cost={Cost as number}
                                        label="%"
                                    />
                                </div>
                            </div>
                            <div></div>
                        </div> */}
                        <div className=" w-full bg-p-gray p-3 rounded-2xl flex flex-col gap-4">
                            <div>
                                <div className=" font-semibold text-xs my-1 flex justify-between">
                                    <p>Number of Guests ({guest})</p>
                                    <p className="text-base">
                                        Total Number of Cocktails ({estDrinksByDrinker})
                                    </p>
                                </div>
                                <div className="relative">
                                    <label htmlFor="labels-range-input" className="sr-only">
                                        Labels range
                                    </label>
                                    <input
                                        id="labels-range-input"
                                        type="range"
                                        value={guest}
                                        onChange={(e: any) => setGuest(e.target.value)}
                                        min={25}
                                        step={25}
                                        max={400}
                                        className="w-full h-1 rounded-lg appearance-none cursor-pointer bg-primary-red"
                                    />
                                    <div className="w-full  gap-1 justify-between ml-1 md:flex hidden">
                                        {GUEST_RANGE_STEPS.map((step) => (
                                            <div
                                                key={step}
                                                className="text-xs text-gray-500 dark:text-gray-400  "
                                            >
                                                {step}
                                                {step < 100 && " "}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="w-full ">
                                <div className="font-semibold text-xs my-1">
                                    Number of hours ({hrToRegister})
                                </div>
                                <div className="relative mb-3">
                                    <label htmlFor="labels-range-input" className="sr-only">
                                        Labels range
                                    </label>
                                    <input
                                        id="labels-range-input"
                                        type="range"
                                        min={Number(minPackageTime)}
                                        max={Number(minPackageTime) + 11}
                                        step={0.5}
                                        value={hrToRegister}
                                        className="w-full h-1 bg-primary-red rounded-lg appearance-none cursor-pointer "
                                        onChange={(e: any) => setHrToRegister(Number(e.target.value))}
                                    />
                                    {DynamicNumbers(minPackageTime, 0.5)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ManagePackage
                    packageList={packageList}
                    curPackage={curPackage}
                    livePackageId={livePackageId}
                    showPackageIncludesInfo={
                        String(curPackage?.type) === PackageType.Standard
                    }
                    packageIncludesHtml={PACKAGE_INCLUDES_HTML}
                    onSelectPackage={setCurPackage}
                    onEditPackage={() => {
                        // Re-sync form values in case they were cleared by opening
                        // the Add New Package modal (shares the same form fields)
                        // and then cancelling it without submitting.
                        if (curPackage) {
                            setValue("packageName", curPackage.name);
                            setSelectedType(curPackage.type);
                            setActiveStatus(curPackage.isActive);
                        }
                        setPackageFormEditForm(true);
                    }}
                    onDeletePackage={(packageId) => {
                        setDeletePackageId(packageId);
                        setDeleteModal(true);
                    }}
                    onAddNewPackage={() => {
                        //reset form values
                        setValue("packageName", "");
                        setSelectedType(PackageType.Internal);
                        setActiveStatus(true);
                        //open modal
                        setAddNewPackageForm(true);
                    }}
                />
                <div className="flex md:flex-row flex-col gap-5  mt-2 ">
                    <div className="flex flex-col gap-5 mb-5 md:w-3/6">
                        <div className="w-full bg-white rounded-2xl p-5 flex flex-col  ">
                            <div className="flex items-center justify-between">
                                <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                                    About your Bartender
                                </p>
                                <button
                                    type="button"
                                    data-tooltip-id="watch-video-tooltip"
                                    onClick={() =>
                                        openVideoModal(
                                            "About your Bartender",
                                            SECTION_HELP_VIDEOS.bartender
                                        )
                                    }
                                    className="flex items-center text-primary-red cursor-pointer"
                                >
                                    <FaCirclePlay size={18} />
                                </button>
                            </div>
                            <div className="">
                                <div className="font-semibold text-sm w-full flex flex-col sm:flex-row  justify-between items-center bg-p-gray p-3 rounded-2xl mt-2">
                                    <div className="mb-2 w-full sm:mb-0 sm:w-auto">
                                        <p>Wage per hour?</p>
                                    </div>
                                    <div className="flex items-center font-semibold text-sm gap-4">
                                        <div className="flex flex-col items-center">
                                            <div className="flex items-center justify-center gap-1">
                                                <p>Cost</p>
                                                <span className="text-primary-red">*</span>
                                            </div>
                                            <div className="flex justify-end gap-2 items-end">
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        className="border w-20 text-center py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                        {...bartenderCostField}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center">
                                            <p> Profit</p>
                                            {showBpp ? (
                                                <div className="flex items-center gap-2">
                                                    <div className="flex flex-row gap-2">
                                                        <input
                                                            className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                            {...bartenderPriceField}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="flex items-center gap-2">
                                                    <div className=" text-sm text-primary-red font-semibold">
                                                        %
                                                    </div>
                                                    <div className="flex flex-row gap-2">
                                                        <input
                                                            className="border w-20 text-center py-1 rounded-full  focus:border-primary-red countInput"
                                                            {...bppField}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex flex-col items-center">
                                            <p>Total</p>
                                            <input
                                                disabled={true}
                                                className="border w-20 text-center py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                type="number"
                                                value={(Number(bartenderCost) + Number(bartenderPrice)).toFixed(2)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full bg-p-gray p-3 rounded-2xl  mt-2">
                                    <div className=" font-semibold text-sm flex justify-between items-center sm:mb-0 mb-2">
                                        <div className="flex items-center justify-center gap-1">
                                            <p>Prep/Clean up time per event?</p>
                                            <span className="text-primary-red">*</span>
                                        </div>
                                        <div className="flex items-center gap-2 mb-1">
                                            <div className=" text-sm  font-semibold">Min</div>
                                            <input
                                                min="30"
                                                max="240"
                                                step={1}
                                                className="border text-center w-20 px-3 py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red "
                                                type="number"
                                                value={Number(bartenderPrepTime || 0)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "e" || e.key === "-" || e.key === "+") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e: any) => {
                                                    const val = e.target.value;
                                                    const wholePart = val.split(".")[0].replace(/[^0-9]/g, "");
                                                    if (wholePart === "") {
                                                        setBartenderPrepTime(0);
                                                        return;
                                                    }
                                                    const intVal = parseInt(wholePart, 10);
                                                    if (isNaN(intVal)) return;
                                                    if (intVal > 240) {
                                                        setBartenderPrepTime(240);
                                                    } else {
                                                        setBartenderPrepTime(intVal);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {selectedType !== "custom_package" && (
                                    <div className="flex gap-4 w-full bg-p-gray p-3 rounded-2xl mt-2">
                                        <div className="w-full">
                                            <div className=" font-semibold text-sm my-2 flex justify-between flex-col lg:flex-row items-center">
                                                <p>How many guests per bartender?</p>
                                                <div className="flex items-center gap-2 justify-between">
                                                    <div className="whitespace-nowrap text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                                                        No. of Guests
                                                    </div>
                                                    <SelectInput
                                                        classes="max-w-40"
                                                        bg="bg-white"
                                                        disabled={false}
                                                        value={selectedGuests}
                                                        onChange={(e: string) => {
                                                            const selectedValue = e;
                                                            // setSelectedGuestsInput(Number(selectedValue));
                                                            setSelectedGuests(Number(selectedValue));
                                                        }}
                                                        options={guestsPerBartenderDrop}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedType === "custom_package" && (
                                    <div className="flex gap-4 w-full"></div>
                                )}
                                {selectedType === "custom_package" && (
                                    <div className="w-full">
                                        <div className=" font-semibold text-sm flex justify-between items-center flex-col lg:flex-row bg-p-gray p-3 rounded-2xl mt-2">
                                            <p>
                                                How many guests per bartender? (Cocktails/Beer/Wine)
                                            </p>
                                            <div className="flex items-center gap-2 justify-between">
                                                <div className="whitespace-nowrap text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                                                    No. of Guests
                                                </div>
                                                <SelectInput
                                                    classes="max-w-40"
                                                    bg="bg-white"
                                                    disabled={false}
                                                    value={selectedGuests}
                                                    onChange={(e: string) => {
                                                        const selectedValue = e;
                                                        setSelectedGuests(Number(selectedValue));
                                                    }}
                                                    options={guestsPerBartenderDrop}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {selectedType === "custom_package" && (
                                    <div className="flex gap-4 w-full ">
                                        <div className="w-full">
                                            <div className=" font-semibold text-sm flex justify-between items-center flex-col lg:flex-row bg-p-gray p-3 rounded-2xl mt-2">
                                                <div className="flex flex-row gap-2 items-center flex-wrap">
                                                    <p>How many guests per bartender? (Beer & Wine) </p>
                                                    <ToggleInput
                                                        onChange={() => {
                                                            setGPB(!GPB);
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex items-center gap-2 justify-between">
                                                    <div className="whitespace-nowrap text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                                                        No. of Guests
                                                    </div>
                                                    <SelectInput
                                                        classes="max-w-40"
                                                        bg="bg-white"
                                                        disabled={false}
                                                        value={selectedGuestBeer}
                                                        onChange={(e: string) => {
                                                            const selectedValue = e;
                                                            // setSelectedGuestsInput(Number(selectedValue));
                                                            setSelectedGuestBeer(Number(selectedValue));
                                                        }}
                                                        options={guestsPerBartenderDrop}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* <div className="flex gap-4 font-semibold w-full bg-p-gray p-3 rounded-2xl mt-2">
                  <p>Want to make the tip-jar mandatory?</p>
                  <div className="mt-1">
                    <ToggleInput
                      checked={tipJar}
                      onChange={() => {
                        setTipJar(!tipJar);
                      }}
                    />
                  </div>
                </div> */}
                                {/* Gratuity moved to the About your Business section, as an open Percentage Tip field only (Custom Tip removed).
                                {!tipJar && (
                                    <div className="w-full bg-p-gray p-3 rounded-2xl mt-2 flex flex-row justify-between pt-5">
                                        <div className="flex justify-between font-semibold text-sm flex-grow flex-col sm:flex-row sm:items-center">
                                            <div className="flex gap-2">
                                                <p>Bartender Tips</p>
                                                <div>
                                                    <ToggleInput
                                                        checked={showBtp}
                                                        onChange={() => {
                                                            setShowBtp(!showBtp);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex flex-row justify-center gap-4 items-center">
                                                <div className="flex flex-col items-center">
                                                    <div className="items-center gap-2 justify-between">
                                                        <div className="focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                                                            Percentage Tip
                                                        </div>
                                                        <SelectInput
                                                            classes="max-w-40"
                                                            bg="bg-white"
                                                            disabled={showBtp}
                                                            value={percentageTip}
                                                            onChange={(e: string) => {
                                                                const tip = e;
                                                                setPercentageTip(Number(tip));
                                                            }}
                                                            options={percentageTips}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex items-center flex-col">
                                                    <p>Custom Tip</p>
                                                    <div className="flex items-center gap-2">
                                                        <div className=" text-sm d font-semibold">$</div>
                                                        <input
                                                            disabled={!showBtp}
                                                            className="border text-center w-20 h-[38px] px-3 py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                            {...customBartenderTipField}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                */}
                            </div>
                        </div>
                        {selectedType !== "custom_package" && (
                            <div className="w-full bg-white rounded-2xl p-5">
                                <div className="flex items-center justify-between">
                                    <p className="md:text-xl text-lg font-bold">
                                        About your Cocktails
                                    </p>
                                    <button
                                        type="button"
                                        data-tooltip-id="watch-video-tooltip"
                                        onClick={() =>
                                            openVideoModal(
                                                "About your Cocktails",
                                                SECTION_HELP_VIDEOS.cocktails
                                            )
                                        }
                                        className="flex items-center text-primary-red cursor-pointer"
                                    >
                                        <FaCirclePlay size={18} />
                                    </button>
                                </div>
                                {/* Replaced by the cocktail supplies breakdown table below.
                                <div className="flex flex-col p-3bg-p-gray rounded-2xl mt-2">
                                    <div className="w-full">
                                        <div className="flex justify-between items-center font-semibold text-sm flex-col sm:flex-row">
                                            <div className="mb-2 w-full sm:mb-0 sm:w-auto">
                                                <p>Price Per Cocktail</p>
                                            </div>
                                            <div className="flex flex-row gap-4">
                                                <div className="flex flex-col items-center">
                                                    <div className="flex items-center justify-center gap-1">
                                                        <p>Cost</p>
                                                        <span className="text-primary-red">*</span>
                                                    </div>
                                                    <input
                                                        className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                                                        title=""
                                                        {...suppliesCostsField}
                                                    />
                                                </div>
                                                <div className="flex flex-col items-center">
                                                    <p>Profit</p>
                                                    {showCSP ? (
                                                        <div className="flex items-center gap-2">
                                                            <input
                                                                className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                                                                {...suppliesPriceField}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-2">
                                                            <div className=" text-sm text-primary-red font-semibold">
                                                                %
                                                            </div>
                                                            <input
                                                                className="border w-20 px-3 py-1 rounded-full   focus:border-primary-red countInput"
                                                                {...sppField}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="flex flex-col items-center">
                                                    <p>Total</p>
                                                    <input
                                                        disabled={true}
                                                        className="border w-20 text-center py-1 rounded-full focus:border-primary-red countInput"
                                                        type="number"
                                                        value={(
                                                            Number(suppliesCosts) + Number(suppliesPrice)
                                                        ).toFixed(2)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                                */}
                                <div className="flex flex-col rounded-2xl mt-2">
                                    <CustomSupplies
                                        supplies={cocktailSupplies}
                                        editDefaultSupplyPrice={editDefaultSupplyPrice}
                                        customSupplyTotal={cocktailSuppliesTotal}
                                        headerLeft={
                                            <div className="flex flex-row gap-2 items-center text-sm">
                                                <p>Include Beer and Wine</p>
                                                <ToggleInput
                                                    checked={includeBeerAndWine}
                                                    onChange={() => {
                                                        setIncludeBeerAndWine(!includeBeerAndWine);
                                                    }}
                                                />
                                                {includeBeerAndWine && (
                                                    <p className="text-gray-500 font-normal">
                                                        (-20% Cocktails)
                                                    </p>
                                                )}
                                            </div>
                                        }
                                    />
                                    <div className="flex justify-end gap-6 font-semibold text-sm mt-2 px-2">
                                        <p>
                                            Cost: $
                                            {Number(suppliesCosts).toFixed(2)}
                                        </p>
                                        <p>
                                            Profit: $
                                            {Number(suppliesPrice).toFixed(2)}
                                        </p>
                                        <p>
                                            Total: $
                                            {(
                                                Number(suppliesCosts) + Number(suppliesPrice)
                                            ).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col gap-5 mb-5 md:w-3/6">
                        <div className="w-full bg-white rounded-2xl p-5 flex-col">
                            <div className="flex items-center justify-between">
                                <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                                    About your Business
                                </p>
                                <button
                                    type="button"
                                    data-tooltip-id="watch-video-tooltip"
                                    onClick={() =>
                                        openVideoModal(
                                            "About your Business",
                                            SECTION_HELP_VIDEOS.business
                                        )
                                    }
                                    className="flex items-center text-primary-red cursor-pointer"
                                >
                                    <FaCirclePlay size={18} />
                                </button>
                            </div>
                            {!tipJar && (
                                <div className="font-semibold text-sm flex justify-between items-center bg-p-gray p-3 rounded-2xl">
                                    <p>Gratuity</p>
                                    <div className="flex items-center gap-2">
                                        <input
                                            className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                                            {...percentageTipField}
                                        />
                                        <div className="text-sm font-semibold">%</div>
                                    </div>
                                </div>
                            )}
                            <div className=" font-semibold text-sm flex justify-between bg-p-gray p-3 rounded-2xl mt-2">
                                <p>Additional Profit</p>
                                <div className="flex items-center gap-2">
                                    <div className=" text-sm  font-semibold">$</div>
                                    <input
                                        className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red  "
                                        {...additionalProfitField}
                                    />
                                </div>
                            </div>
                            <div className="font-semibold text-sm flex justify-between items-center bg-p-gray p-3 rounded-2xl mt-2">
                                <p>Payment Processing Fee</p>
                                <div className="flex items-center gap-2">
                                    <input
                                        className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                                        {...paymentProcessingFeeField}
                                    />
                                    <div className="text-sm font-semibold">%</div>
                                </div>
                            </div>
                            <div className="font-semibold text-sm flex justify-between items-center bg-p-gray p-3 rounded-2xl mt-2 flex-col lg:flex-row">
                                <div className="mb-2 w-full sm:mb-0 lg:w-auto">
                                    <p>Expense</p>
                                </div>
                                <div className="flex flex-row gap-4">
                                    <div className="flex items-center flex-col">
                                        <div className="flex items-center justify-center gap-1">
                                            <p>Fixed</p>
                                            <span className="text-primary-red">*</span>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                className="border w-20 py-1 rounded-full text-center focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                {...deliveryCostField}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center flex-col">
                                        <p>Insurance</p>
                                        <div className="flex items-center gap-2">
                                            <input
                                                className="border w-20 text-center py-1 rounded-full  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                {...insuranceExpenseField}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center flex-col">
                                        <p>Marketing</p>
                                        <div className="flex items-center gap-2">
                                            <input
                                                className="border w-20 text-center py-1 rounded-full  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                {...marketingExpenseField}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center flex-col">
                                        <p>Other</p>
                                        <div className="flex items-center gap-2">
                                            <input
                                                className="border w-20 text-center py-1 rounded-full  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                {...otherExpenseField}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="flex justify-between items-center font-semibold text-sm bg-p-gray p-3 rounded-2xl mt-2">
                                <div className="flex items-center justify-center gap-1">
                                    <p>{"Minimum package time?"}</p>
                                    <span className="text-primary-red">*</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <div className=" text-sm d font-semibold">Hr</div>
                                    <input
                                        min="30"
                                        max="250"
                                        className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                        type="number"
                                        title=""
                                        value={minPackageTime}
                                        onChange={(e: any) => {
                                            const val = e.target.value;
                                            if (e.target.value > 12) {
                                                setMinPackageTime(12);
                                                setHrToRegister(12);
                                            } else {
                                                if (val.indexOf(".") == -1) {
                                                    if (val > 0) {
                                                        setMinPackageTime(e.target.value);
                                                        setHrToRegister(e.target.value);
                                                    } else {
                                                        setMinPackageTime(1);
                                                        setHrToRegister(1);
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div> */}
                            <div className="flex justify-between items-center font-semibold text-sm bg-p-gray p-3 rounded-2xl mt-2">
                                <p>Minimum Price</p>
                                <div className="flex items-center gap-2">
                                    <div className=" text-sm d font-semibold">$</div>
                                    <input
                                        className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                        {...minPackagePriceField}
                                    />
                                </div>
                            </div>
                            <div className="font-semibold text-sm bg-p-gray p-3 rounded-2xl mt-2">
                            <div className="flex justify-between items-center flex-col lg:flex-row">
                                <div className="mb-2 w-full sm:mb-0 lg:w-auto">
                                    <p>Distance</p>
                                </div>
                                <div className="flex flex-row gap-4">
                                    <div className="flex items-center flex-col">
                                        <p>Min (mi)</p>
                                        <div className="flex items-center">
                                            <input
                                                className="border w-20 py-1 rounded-full text-center bg-gray-100 text-gray-400 focus:outline-none"
                                                type="text"
                                                value={30}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center flex-col">
                                        <div className="flex items-center justify-center gap-1">
                                            <p>Max (mi)</p>
                                            <span className="text-primary-red">*</span>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                className="border w-20 py-1 rounded-full text-center focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                type="number"
                                                min={30}
                                                max={200}
                                                value={maxDistance}
                                                onChange={(e) => {
                                                    const val = Number(e.target.value);
                                                    if (isNaN(val)) return;
                                                    setMaxDistance(val);
                                                    if (val > 200) {
                                                        setMaxDistanceError(
                                                            "Max Distance can't be more than 200 miles."
                                                        );
                                                    } else if (val < 30) {
                                                        setMaxDistanceError(
                                                            "Max Distance can't be less than 30 miles."
                                                        );
                                                    } else {
                                                        setMaxDistanceError("");
                                                    }
                                                }}
                                                onBlur={() => {
                                                    setMaxDistance((prev) =>
                                                        Math.min(200, Math.max(30, prev || 30))
                                                    );
                                                    setMaxDistanceError("");
                                                }}
                                            />
                                        </div>
                                        {maxDistanceError && (
                                            <p className="text-primary-red text-xs mt-1 whitespace-nowrap">
                                                {maxDistanceError}
                                            </p>
                                        )}
                                    </div>
                                    {maxDistance > 30 && (
                                        <div className="flex items-center flex-col">
                                            <div className="flex items-center justify-center gap-1">
                                                <p>$/mile</p>
                                                <span className="text-primary-red">*</span>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    className="border w-20 py-1 rounded-full text-center focus:outline-none  focus:ring-1 focus:ring-primary-red"
                                                    {...mileageFeeField}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 mt-4">
                                <div className="flex flex-col gap-1">
                                    <p>Home Address (Business Address)</p>
                                    {/* Defaults to the business address; edits only apply to this estimate.
                                        Keyed so the uncontrolled input picks up the address once it loads. */}
                                    <PlacesInput
                                        key={businessAddress ? "home-loaded" : "home-empty"}
                                        height={34}
                                        classes="bg-white border"
                                        defaultValue={businessAddress?.address}
                                        error={null}
                                        onAddressSelected={(address, lat, lng) =>
                                            setBusinessAddress({ address, lat, lng })
                                        }
                                    />
                                </div>
                                <div className="flex flex-col gap-1">
                                    <p>Event Address</p>
                                    <PlacesInput
                                        height={34}
                                        classes="bg-white border"
                                        defaultValue={eventAddress?.address}
                                        error={null}
                                        onAddressSelected={(address, lat, lng) =>
                                            setEventAddress({ address, lat, lng })
                                        }
                                    />
                                </div>
                                {eventDistance !== null && (
                                    <div className="flex flex-col gap-1 text-xs">
                                        <div className="flex justify-between">
                                            <p>Distance to event</p>
                                            <p>{eventDistance.toFixed(1)} mi</p>
                                        </div>
                                        <div className="flex justify-between">
                                            <p>
                                                Mileage ({billableMiles} mi beyond{" "}
                                                {FREE_MILES} mi × $
                                                {USFormatePriceWithDecimal(Number(mileageFee) || 0)}
                                                /mi × 2 round trip)
                                            </p>
                                            <p>${USFormatePriceWithDecimal(mileageCharge)}</p>
                                        </div>
                                        {eventDistance > maxDistance && (
                                            <p className="text-primary-red">
                                                Event is beyond your max distance of {maxDistance} mi.
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                            </div>
                        </div>

                        <div className="w-full bg-white rounded-2xl  p-5  ">
                            <div className="flex items-center justify-between">
                                <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                                    Add-ons
                                </p>
                                <div className="flex items-center gap-3 text-black ">
                                    <button
                                        type="button"
                                        data-tooltip-id="watch-video-tooltip"
                                        onClick={() =>
                                            openVideoModal("Add-ons", SECTION_HELP_VIDEOS.addOns)
                                        }
                                        className="flex items-center text-primary-red cursor-pointer"
                                    >
                                        <FaCirclePlay size={18} />
                                    </button>
                                    <FaCirclePlus
                                        className="cursor-pointer text-gray-400 text-xl"
                                        onClick={() => {
                                            setAddOnIsEdit(false);
                                            setAddOnName("");
                                            setAddOnImage({ img: "" });
                                            setAddOnPrice("");
                                            setAddOnCost("");
                                            setAddOnMinPrice("");
                                            setAddOnType("bartender");
                                            setAddOnDesc("");
                                            setAddOnForm(true);
                                            setIncludeInPackage(false);
                                            setAddOnPrepTime(false);
                                        }}
                                    />
                                </div>
                            </div>
                            {addOns.filter((a) => {
                                return a.is_btc_edit === false;
                            }).length ? (
                                <>
                                    <p className="font-semibold mb-2">Required</p>
                                    <div className="flex flex-col gap-4 bg-p-gray p-3 rounded-2xl">
                                        <div className="flex gap-4">
                                            <div className="flex flex-col flex-wrap gap-2 w-full p-x-10">
                                                {addOns
                                                    .filter((a) => {
                                                        return a.is_btc_edit === false;
                                                    })
                                                    .map((i, index) => {
                                                        return (
                                                            <div
                                                                key={i.id}
                                                                className="flex items-center gap-2 justify-between"
                                                            >
                                                                <div className="flex gap-2">
                                                                    {i?.img ? (
                                                                        <img
                                                                            className="w-14 h-14 rounded-md"
                                                                            src={i?.img}
                                                                            alt=""
                                                                        />
                                                                    ) : i?.addonImage ? (
                                                                        <img
                                                                            className="w-14 h-14 rounded-md"
                                                                            src={i?.addonImage.img}
                                                                            alt=""
                                                                        />
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <div>
                                                                        <h1
                                                                            key={i.id}
                                                                            className="flex items-center  font-semibold text-gray-500"
                                                                        >
                                                                            {/* <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "} */}
                                                                            {i.name}
                                                                        </h1>

                                                                        <p className="font-semibold text-gray-500">
                                                                            ${" "}
                                                                            {USFormatePriceWithDecimal(
                                                                                (
                                                                                    getAddonPrice(
                                                                                        i,
                                                                                        guest,
                                                                                        numberOfBartenders,
                                                                                        billableHours,
                                                                                        bartenderPrepTime,
                                                                                        drinker
                                                                                    ) / 100
                                                                                ).toFixed(2)
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="flex gap-2 items-center">
                                                                    {roles == "admin" && (
                                                                        <ToggleInput
                                                                            // disabled={roles !=='admin'}
                                                                            disabled={
                                                                                i.is_btc_edit === false && !roles
                                                                            }
                                                                            onChange={() => {
                                                                                setAddOns((prev) => {
                                                                                    const value = prev.map((item) => {
                                                                                        if (item.id === i.id) {
                                                                                            return {
                                                                                                ...item,
                                                                                                auto_include:
                                                                                                    !item.auto_include,
                                                                                            };
                                                                                        }
                                                                                        return item;
                                                                                    });
                                                                                    setSupplyDescription(
                                                                                        `${generateDescription(
                                                                                            selectedSupplies
                                                                                        )}\n${generateAddsOnDescription([
                                                                                            ...value,
                                                                                        ])}`
                                                                                    );
                                                                                    return value;
                                                                                });
                                                                            }}
                                                                            checked={i.auto_include}
                                                                        />
                                                                    )}
                                                                    {
                                                                        // true
                                                                        // (roles ==='admin' || (roles !== 'admin' && !i.is_btc_edit) )
                                                                        ((i.is_btc_edit === true && !roles) ||
                                                                            roles === "admin") && (
                                                                            <div
                                                                                data-testid="delete-icon "
                                                                                className="p-2 bg-p-gray rounded-full font-bold cursor-pointer "
                                                                                onClick={() => {
                                                                                    deleteAddOn(i.id as string);
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={deleteIcon}
                                                                                    className="min-w-3"
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {i.id && (
                                                                        <div
                                                                            className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                                                            onClick={() => editAddonForm(i)}
                                                                        >
                                                                            <FiEdit2 size={14} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}

                            {addOns.filter((a) => {
                                return a.is_btc_edit === true;
                            }).length > 0 && (
                                    <>
                                        <p className="font-semibold mt-2">Optional</p>
                                        <div className="flex flex-col gap-4 bg-p-gray p-3 rounded-2xl mt-3">
                                            <div className="flex gap-4">
                                                <div className="flex flex-col flex-wrap gap-2 w-full p-x-10">
                                                    {addOns
                                                        .filter((a) => {
                                                            return a.is_btc_edit === true;
                                                        })
                                                        .map((i, index) => {
                                                            return (
                                                                <div
                                                                    key={i.id}
                                                                    className="flex items-center gap-2 justify-between"
                                                                >
                                                                    <div className="flex gap-2">
                                                                        {i?.img ? (
                                                                            <img
                                                                                className="w-14 h-14 rounded-md"
                                                                                src={i?.img}
                                                                                alt=""
                                                                            />
                                                                        ) : i?.addonImage ? (
                                                                            <img
                                                                                className="w-14 h-14 rounded-md"
                                                                                src={i?.addonImage.img}
                                                                                alt=""
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <div>
                                                                            <h1
                                                                                key={i.id}
                                                                                className="flex items-center  font-semibold text-gray-500"
                                                                            >
                                                                                {/* <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "} */}
                                                                                {i.name}
                                                                            </h1>

                                                                            <p className="font-semibold text-gray-500">
                                                                                ${" "}
                                                                                {USFormatePriceWithDecimal(
                                                                                    (
                                                                                        getAddonPrice(
                                                                                            i,
                                                                                            guest,
                                                                                            numberOfBartenders,
                                                                                            billableHours,
                                                                                            bartenderPrepTime,
                                                                                            drinker
                                                                                        ) / 100
                                                                                    ).toFixed(2)
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="flex gap-2 items-center">
                                                                        <ToggleInput
                                                                            // disabled={roles !=='admin'}
                                                                            disabled={i.is_btc_edit === false && !roles}
                                                                            onChange={() => {
                                                                                setAddOns((prev) => {
                                                                                    const value = prev.map((item) => {
                                                                                        if (item.id === i.id) {
                                                                                            return {
                                                                                                ...item,
                                                                                                auto_include: !item.auto_include,
                                                                                            };
                                                                                        }
                                                                                        return item;
                                                                                    });
                                                                                    setSupplyDescription(
                                                                                        `${generateDescription(
                                                                                            selectedSupplies
                                                                                        )}\n${generateAddsOnDescription([
                                                                                            ...value,
                                                                                        ])}`
                                                                                    );
                                                                                    return value;
                                                                                });
                                                                            }}
                                                                            checked={i.auto_include}
                                                                        />
                                                                        {
                                                                            // true
                                                                            // (roles ==='admin' || (roles !== 'admin' && !i.is_btc_edit) )
                                                                            ((i.is_btc_edit === true && !roles) ||
                                                                                roles === "admin") && (
                                                                                <div
                                                                                    data-testid="delete-icon "
                                                                                    className="p-2 bg-p-gray rounded-full font-bold cursor-pointer "
                                                                                    onClick={() => {
                                                                                        deleteAddOn(i.id as string);
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={deleteIcon}
                                                                                        className="min-w-3"
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {i.id && (
                                                                            <div
                                                                                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                                                                onClick={() => editAddonForm(i)}
                                                                            >
                                                                                <FiEdit2 size={14} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                        </div>
                        <AddOnModal
                            isOpen={addAddOnForm}
                            onClose={closeAddOnModal}
                            addOnIsEdit={addOnIsEdit}
                            roles={roles}
                            isEditByBtC={isEditByBtC}
                            addOnImage={addOnImage}
                            uploadAddOnImg={uploadAddOnImg}
                            removeAddOnImage={removeAddOnImage}
                            addOnName={addOnName}
                            setAddOnName={setAddOnName}
                            addOnType={addOnType}
                            setAddOnType={setAddOnType}
                            addOnDesc={addOnDesc}
                            setAddOnDesc={setAddOnDesc}
                            addOnCost={addOnCost}
                            setAddOnCost={setAddOnCost}
                            addOnPrice={addOnPrice}
                            setAddOnPrice={setAddOnPrice}
                            addOnMinPrice={addOnMinPrice}
                            setAddOnMinPrice={setAddOnMinPrice}
                            includeInPackage={includeInPackage}
                            setIncludeInPackage={setIncludeInPackage}
                            addOnPrepTime={addOnPrepTime}
                            setAddOnPrepTime={setAddOnPrepTime}
                            addOnError={addOnError}
                            canSubmit={canSubmit}
                            onSubmit={addOnIsEdit ? updateAddOn : addAddOn}
                        />
                    </div>
                </div>
                {/* Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
                {selectedType !== "custom_package" && (
                    <div className="w-full flex flex-col md:flex-row gap-5 mt-4">
                        <div className="w-full bg-white rounded-2xl p-5">
                            <div className=" font-semibold my-2 flex justify-between items-center ">
                                <p>{"Custom Quote Description"}</p>
                            </div>
                            <div className="flex">
                                <textarea
                                    disabled={false}
                                    rows={12}
                                    onChange={(e) => setCustomQuoteDescription(e.target.value)}
                                    className="w-full px-4 py-3 bg-p-gray rounded-xl focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    placeholder={""}
                                    value={customQuoteDescription}
                                />
                            </div>
                            {customQuotePackageId && (
                                <div className="flex justify-start mt-3">
                                    <button
                                        disabled={!canSubmit || isCustomQuoteUpdating}
                                        className={`text-white rounded-full px-4 py-2 w-fit ${!canSubmit || isCustomQuoteUpdating ? "bg-gray-400" : "bg-primary-red"
                                            }`}
                                        onClick={updateCustomQuoteDescriptionOnly}
                                    >
                                        {isCustomQuoteUpdating ? (
                                            <Loader color="bg-gray-50 " />
                                        ) : (
                                            "Update"
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                */}
                {selectedType === "custom_package" && (
                    <CustomSupplies
                        supplies={customSupplies}
                        editDefaultSupplyPrice={editDefaultSupplyPrice}
                        customSupplyTotal={customSupTotalPlus}
                    />
                )}
                <div className="flex justify-end items-center ">
                    <button
                        disabled={!canSubmit}
                        className={`mt-3 text-white rounded-full px-4 py-2 w-fit ${!canSubmit ? "bg-gray-400" : "bg-primary-red"
                            }`}
                        onClick={
                            params?.isCompanyCreation ? () => setModal(true) : updatePackage
                        }
                    >
                        {isLoading ? (
                            <Loader color="bg-gray-50 " />
                        ) : curPackage && curPackage.id ? (
                            "Update package"
                        ) : (
                            "Create Package"
                        )}
                    </button>
                </div>
            </div>
            <AddNewPackageModal
                isOpen={addNewPackageForm}
                onClose={() => setAddNewPackageForm(false)}
                register={register}
                packageNameError={packageFormErrors.packageName}
                onSubmit={() => addNewPackagefn()}
            />
            <EditPackageModal
                isOpen={packageFormEditForm}
                onClose={() => setPackageFormEditForm(false)}
                register={register}
                packageNameError={packageFormErrors.packageName}
                onSubmit={() => addNewPackagefn()}
            />
            {addSupplyForm && (
                <FormModal
                    overflow="overflow-hidden "
                    modalTitle="Add Supply"
                    isOpen={addSupplyForm}
                    width="lg:w-3/6 md:w-5/6 w-full"
                    height="overflow-y-auto"
                    onClose={() => {
                        setAddSupplyForm(false);
                        setAddError("");
                    }}
                >
                    <div className="w-full ">
                        <div className="font-semibold my-2">Supply Name</div>
                        <input
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                            maxLength={50}
                            value={supplyInput}
                            onChange={(e) => {
                                setSupplyInput(e.target.value);
                            }}
                            onFocus={() => {
                                setAddError("");
                            }}
                            type="text"
                            placeholder="Supply Name"
                        />
                        {addError && (
                            <p className="text-primary-red text-xs ">{addError}</p>
                        )}
                        <div className="flex justify-end mt-2 ">
                            {/* <Button type="button" onClick={addNewSupply}>
                        Add
                      </Button> */}
                            <p
                                className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
                                onClick={() => addNewSupplyTab()}
                            >
                                Add
                            </p>
                        </div>
                    </div>
                </FormModal>
            )}
            <ChangesAlert
                title={"Save Changes"}
                desc={`Are you sure you want to save this changes?`}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => {
                    setModal(false);
                }}
                handleSaveChanges={updatePackage}
                isOpen={modal}
            />
            <ChangesAlert
                title={"Delete Package"}
                desc={`Are you sure you want to delete this package?`}
                isLoading={deleteLoader}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => {
                    setDeleteModal(false);
                    setDeletePackageId("");
                }}
                handleSaveChanges={() => deletePackage(deletePackageId)}
                isOpen={deleteModal}
            />
            <VideoModal
                isOpen={videoModal.isOpen}
                onClose={closeVideoModal}
                title={videoModal.title}
                videoUrl={videoModal.url}
            />
            <ReactTooltip id="watch-video-tooltip" content="Watch Video" place="top" />
        </div>
    );
};
export default PriceCalculation;
